import type { ReactNode } from 'react'
import type { Tone } from '../lib/labels'

export function Pill({ tone = 'gray', children, className = '', title }: { tone?: Tone; children: ReactNode; className?: string; title?: string }) {
  return <span className={`pill p-${tone} ${className}`} title={title}>{children}</span>
}
